export const CHANGE_QTY_LABEL = "CHANGE_QTY_LABEL";
export const RESET_QTY_LABEL = "RESET_QTY_LABEL";
export const RESET_QTY_LABEL_ALL = "RESET_QTY_LABEL_ALL";
